export default __webpack_public_path__ + "static/media/lentil.7188053f.png";